





























import Vue from 'vue';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';

export default Vue.extend<any, any, any, any>({
  mixins: [breakpointsMixin, iconsMixin],
  methods: {
    getStarted() {
      this.$store.commit('shipments/startNewSpotMarketBidProcess');
      this.$emit('get-started');
    },
    goToDashboard() {
      window.location.href = '/customer/spot-market?tab=Bids+In+Progress';
    },
  },
});
